module.exports = __webpack_public_path__ + "static/img/logo3.a173cfb3.png";